/* LiberLive — White Monochrome color sync. The Section 03 gallery selector is the shared
   product-color controller: clicking Boundless White / Gravity Black dispatches
   `liberlive:product-color-change` {group,color} at document; every Section 02 hero and
   Section 03 gallery sharing that color_sync_group crossfades its white/black media.
   Multi-instance, Theme-Editor safe, no listener duplication, remembers color per group. */
(function () {
  var store = window.__llColorSync;
  if (!store) {
    store = window.__llColorSync = { colors: {} };
    document.addEventListener('liberlive:product-color-change', function (e) {
      var d = e.detail || {};
      if (!d.group) return;
      store.colors[d.group] = (d.color === 'black') ? 'black' : 'white';
      applyColor(d.group, store.colors[d.group]);
    });
  }

  function applyColor(group, color) {
    var black = color === 'black';
    // Section 02 heroes
    document.querySelectorAll('[data-cs][data-color-sync-group]').forEach(function (root) {
      if (root.getAttribute('data-color-sync-group') !== group) return;
      root.querySelectorAll('.cs-frame').forEach(function (f) { f.classList.toggle('is-black', black); });
    });
    // Section 03 galleries
    document.querySelectorAll('[data-dg][data-color-sync-group]').forEach(function (root) {
      if (root.getAttribute('data-color-sync-group') !== group) return;
      root.querySelectorAll('.dg-tile').forEach(function (t) { t.classList.toggle('is-black', black); });
      root.querySelectorAll('.dg-swatchbtn').forEach(function (btn) {
        btn.setAttribute('aria-pressed', String(btn.getAttribute('data-color') === color));
      });
    });
  }

  function bindGallery(root) {
    if (root.dataset.dgBound === '1') return;
    root.dataset.dgBound = '1';
    var group = root.getAttribute('data-color-sync-group') || 'c2-primary';
    root.querySelectorAll('.dg-swatchbtn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var color = btn.getAttribute('data-color') === 'black' ? 'black' : 'white';
        document.dispatchEvent(new CustomEvent('liberlive:product-color-change', { detail: { group: group, color: color } }));
      });
    });
  }

  function initGroupsIn(scope) {
    (scope || document).querySelectorAll('[data-dg][data-color-sync-group]').forEach(bindGallery);
    // decide + apply the current colour for every group that now has DOM present
    var groups = {};
    document.querySelectorAll('[data-color-sync-group]').forEach(function (el) {
      var g = el.getAttribute('data-color-sync-group');
      if (!g || groups[g]) return;
      groups[g] = true;
      var initial = store.colors[g];
      if (!initial) {
        var gallery = document.querySelector('[data-dg][data-color-sync-group="' + g + '"]');
        initial = (gallery && gallery.getAttribute('data-default-color')) || 'white';
        if (initial !== 'black') initial = 'white';
      }
      store.colors[g] = initial;
      applyColor(g, initial);
    });
  }

  function initAll(scope) { initGroupsIn(scope); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    // drop bound flag so a re-added gallery rebinds cleanly; colours stay in memory
    var g = e.target.querySelector('[data-dg]');
    if (g) g.dataset.dgBound = '';
  });
  document.addEventListener('shopify:block:select', function (e) {
    // when a colour block is selected in the editor, reflect it live
    var btn = e.target.closest && e.target.closest('.dg-swatchbtn');
    if (btn) btn.click();
  });
})();
